import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Text } from '@pinpoint/design-kit';
import CONSTANTS from 'src/store/constants';

import useModel from 'src/hooks/swr/useModel';
import { CellRegulatoryTag, CellTag } from 'src/components/models/cells';
import BaseDialog from './base';
/* eslint-disable react/prop-types */

export function HideDialog({ isOpen, actions, download }) {
  const hideString = download?.hiddenByRole ? 'Show' : 'Hide';
  const { data: model } = useModel({
    modelId: download?.metadataPayload?.source_id,
    options: {
      headers: {
        'X-Fields': 'id,name,dataModelType,modelData{metadataPayload},framework',
      },
    },
    config: { revalidateOnMount: true, shouldFetch: isOpen && download?.metadataPayload?.source_id !== undefined },
  });
  const dataModelType = model?.dataModelType;
  const fairness = model?.modelData?.metadataPayload?.fairness;
  const framework = model?.framework;
  return (
    <BaseDialog
      isOpen={isOpen}
      actions={actions}
      title={{
        text: `${hideString} Download`,
        backgroundColor: 'brand300',
        color: 'white',
        textSize: 'title',
        icon: <Icon name="AlertSolid" color="white" viewBox="0 0 24 24" size="3.125rem" m={{ r: '1rem' }} />,
      }}
      items={{
        content: [
          <Text textSize="subtitle" textColor="tabSelected" data-test="visibility-content">
            Are you sure you want to {hideString.toLowerCase()}
            {dataModelType ? (
              <>
                <CellTag
                  value={{ dataModelType, isRemediated: fairness ?? false }}
                  bg="white"
                  m={{ l: '.5rem', r: framework ? '.25rem' : '.15rem' }}
                />
                <CellRegulatoryTag value={{ framework }} m={{ r: '.75rem' }} />
              </>
            ) : (
              ' '
            )}
            {download?.name
              ?.replace(`${CONSTANTS.TAL_MODEL.TAG_NAME[dataModelType]}:`, '')
              .replace(' (REMEDIATED)', '')}
            ?
          </Text>,
        ],
        buttons: [
          {
            text: 'YES',
            textSize: 'body',
            close: true,
          },
        ],
      }}
    />
  );
}

/* eslint-disable react/require-default-props */
HideDialog.propTypes = {
  download: PropTypes.shape({
    hiddenByRole: PropTypes.string,
    name: PropTypes.string.isRequired,
    metadataPayload: PropTypes.shape({
      source_id: PropTypes.number,
    }).isRequired,
  }),
  isOpen: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    cancel: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    close: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    handlers: PropTypes.arrayOf(
      PropTypes.shape({
        before: PropTypes.func,
        on: PropTypes.func.isRequired,
        after: PropTypes.func,
      })
    ),
  }).isRequired,
  title: PropTypes.shape({
    text: PropTypes.string.isRequired,
    textSize: PropTypes.string,
    backgroundColor: PropTypes.string.isRequired,
    color: PropTypes.string,
  }),
  items: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.element).isRequired,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        textSize: PropTypes.string,
        close: PropTypes.bool.isRequired,
      }).isRequired
    ),
  }).isRequired,
};
/* eslint-enable */

export default HideDialog;
